import React from 'react';
import b_ from 'b_';
import cn from 'classnames';
import { Link } from '../Link';
import { brandName, headings } from '../../data';
import './style.scss';

const b = b_.lock('BreadCrumbs');

const rootCrumb = ['/', brandName];

export const BreadCrumbs = ({
  className,
  crumbs = []
}) => {
  const isRootCrumbHidden = crumbs.length === 1 || crumbs.length > 2;

  return (
    <ul
      className={cn(b(), className)}
      itemScope
      itemType='http://schema.org/BreadcrumbList'
    >
      {[rootCrumb, ...crumbs].map(([path, name], index) => (
        <li
          className={b(
            'item',
            { rootCrumbHidden: (index === 0 && isRootCrumbHidden) }
          )}
          itemProp='itemListElement'
          itemScope
          itemType='http://schema.org/ListItem'
          key={path}
        >
          <Link to={path} itemProp='item'>
            <span itemProp='name'>{name || headings[path]}</span>
          </Link>
          <meta itemProp='position' content={index + 1} />
        </li>
      ))}
    </ul>
  );
};
